// test2582
(2582 && 0);
